import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ element, path }) {
  const details = localStorage.getItem('token');
  if (details) {
    return details ? element : <Navigate to='/permission-denied' />
  } else {
    return <Navigate to='/permission-denied' />
  }
}

export default ProtectedRoute;